// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_parentCard__U32\\+W {
  max-width: 100%;
  min-height: 120px;
  border: 1px solid #8080802e;
  background-color: #ffffff2e;
  padding: 1rem; }

.styles_parentTitle__L\\+1xg {
  font-size: 1rem;
  font-weight: 600;
  color: #72abab;
  margin: 0; }

.styles_parentName__0OlNB {
  font-size: 1.1rem;
  font-weight: 500;
  color: #808080b8;
  margin: 0; }

.styles_parentText__yiDf\\+ {
  font-size: 0.9rem;
  color: #808080e6;
  line-height: 1.4;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden; }

.styles_noParent__q5RVH {
  color: #808080b8;
  font-style: italic;
  text-align: center; }
`, "",{"version":3,"sources":["webpack://./src/modules/mapal/submodules/features/components/FeatureParentCard/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI,eAAe;EACf,iBAAiB;EACjB,2BCQc;EDPd,2BCAe;EDCf,aAAa,EAAA;;AAGjB;EACI,eAAe;EACf,gBAAgB;EAChB,cC0BgB;EDzBhB,SAAS,EAAA;;AAGb;EACI,iBAAiB;EACjB,gBAAgB;EAChB,gBCHc;EDId,SAAS,EAAA;;AAGb;EACI,iBAAiB;EACjB,gBCRc;EDSd,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB,EAAA;;AAGpB;EACI,gBCnBc;EDoBd,kBAAkB;EAClB,kBAAkB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.parentCard {\n    max-width: 100%;\n    min-height: 120px;\n    border: 1px solid $grey18;\n    background-color: $white18;\n    padding: 1rem;\n}\n\n.parentTitle {\n    font-size: 1rem;\n    font-weight: 600;\n    color: $ocean_blue;\n    margin: 0;\n}\n\n.parentName {\n    font-size: 1.1rem;\n    font-weight: 500;\n    color: $grey72;\n    margin: 0;\n}\n\n.parentText {\n    font-size: 0.9rem;\n    color: $grey90;\n    line-height: 1.4;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.noParent {\n    color: $grey72;\n    font-style: italic;\n    text-align: center;\n} ","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"parentCard": `styles_parentCard__U32+W`,
	"parentTitle": `styles_parentTitle__L+1xg`,
	"parentName": `styles_parentName__0OlNB`,
	"parentText": `styles_parentText__yiDf+`,
	"noParent": `styles_noParent__q5RVH`
};
export default ___CSS_LOADER_EXPORT___;
